import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-helps-with',
  templateUrl: './header-column-helps-with.component.html',
  styleUrls: ['./header-column-helps-with.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnHelpsWithComponent extends HeaderColumnComponent {}
